import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { AdminLevel } from '@medical-association/shared';
import { useState } from 'react';
import AlertManagement from './sections/AlertManagement';
import LocationManagement from './sections/LocationManagement';
import MemberManagement from './sections/MemberManagement';
import NewsManagement from './sections/NewsManagement';
import ProductManagement from './sections/ProductManagement';

const AdminDashboard = () => {
  const [activeTab, setActiveTab] = useState('locations');

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">Admin Dashboard</h1>
      
      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="grid w-full grid-cols-5">
          <TabsTrigger value="locations">Locations</TabsTrigger>
          <TabsTrigger value="products">Products</TabsTrigger>
          <TabsTrigger value="members">Members</TabsTrigger>
          <TabsTrigger value="news">News & Events</TabsTrigger>
          <TabsTrigger value="alerts">Alerts</TabsTrigger>
        </TabsList>

        <TabsContent value="locations">
          <LocationManagement />
        </TabsContent>

        <TabsContent value="products">
          <ProductManagement />
        </TabsContent>

        <TabsContent value="members">
          <MemberManagement />
        </TabsContent>

        <TabsContent value="news">
          <NewsManagement />
        </TabsContent>

        <TabsContent value="alerts">
          <AlertManagement />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default AdminDashboard; 